/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_MaturityInputs */

const en_pc_cmp_r_maturity = /** @type {(inputs: Pc_Cmp_R_MaturityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maturity`)
};

const zh_pc_cmp_r_maturity = /** @type {(inputs: Pc_Cmp_R_MaturityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成熟度`)
};

/**
* | output |
* | --- |
* | "Maturity" |
*
* @param {Pc_Cmp_R_MaturityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_maturity = /** @type {((inputs?: Pc_Cmp_R_MaturityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_MaturityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_maturity(inputs)
	return zh_pc_cmp_r_maturity(inputs)
});
export { pc_cmp_r_maturity as "pc.cmp.r.maturity" }